<template>
	<div class="monitoringBox">
		<div class="navBox">
			<ul>
				<router-link tag='h3' to='/monitoring'>回到首页</router-link>
				<router-link tag='li' :class='{active:navShow3}'  to='/creatNav/callCase?caseType=1'>创建</router-link>
				<router-link tag='li' :class='{active:navShow1}' to='/creatNav/consultingCase?caseType=1&status=1'>进行中案件</router-link>
				<router-link tag='li' :class='{active:navShow2}' to='/creatNav/consultingCase?caseType=1&status=2'>已完成案件</router-link>
        <router-link tag='li' :class='{active:navShow4}' to='/creatNav/consultingCase?caseType=1&status=3'>已关闭案件</router-link>
			</ul>			
		</div>
		<div class="viewBox">
			<p class="back" @click="back">返回上一页</p>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				msg:'',
				navShow:true,
				navShow1:false,
				navShow2:false,
				navShow3:false,
        navShow4:false,
				numBtn:''
			}
		},
		mounted(){
			this.routerShow(this.$route)
		},
		methods:{
			back(){
				this.$router.go(-1)
			},
			routerShow(to){
        console.log(to.name)
				var routePath=to.name;
        console.log(routePath)
				this.navShow1=false;				
				this.navShow2=false;				
				this.navShow3=false;	
        this.navShow4=false;	
				if(routePath == 'creatCase1' && this.$route.query.status == 1 || routePath == 'consultingCase' && this.$route.query.status == 1){
					this.navShow1=true;
				}else if(routePath == 'creatCase1' && this.$route.query.status == 2 || routePath == 'consultingCase' && this.$route.query.status == 2){
					this.navShow2=true;
				}else if(routePath == 'creatCase1' && this.$route.query.status == 3 || routePath == 'consultingCase' && this.$route.query.status == 3){
					this.navShow4=true;
				}else if(routePath == 'callCase' || routePath == 'creatCase'){
					this.navShow3=true;
				}				
			}
		},
		watch:{
			$route(to){
				this.numBtn=this.$route.query.status
				this.routerShow(to)
			},
			numBtn(){
				this.routerShow(this.$route)
			}
		}
	}
</script>

<style scoped="scoped">
.monitoringBox{padding: 20px;overflow: hidden;}
.monitoringBox .navBox{float: left;width: 250px;background: white;}
.monitoringBox .navBox h3{font-size: 18px;color: #00abfa;font-weight: normal;text-align: center;line-height: 50px;cursor: pointer;}
.monitoringBox .navBox li{font-size: 16px;color: #333;line-height: 50px;padding: 0 20px;cursor: pointer;}
.monitoringBox .navBox li:hover{color: #00abfa;}
/*.monitoringBox .navBox li.router-link-active{background: #00abfa;color: #fff;}*/
.monitoringBox .navBox li.active{background: #00abfa;color: #fff;}
.monitoringBox .viewBox{float: left;width:calc(100% - 310px);margin-left: 20px;background: white;padding: 20px;}
.back{background: url(./img/back.png) left center no-repeat;padding-left: 20px;background-size: 15px;cursor: pointer;}
</style>


// WEBPACK FOOTER //
// src/views/cmd_center/monitoringCase/creatNav.vue